import Button from "primevue/button";
import DataTable from "../../datatable";
import TTableFilters from "../TTableFilters.vue";
import Column from "primevue/column";
import InputText from "primevue/inputtext/InputText";
import Checkbox from "primevue/checkbox";
import CustomCheckbox from "../../TemplateComponent/custom-checkbox";
import FileUpload from "primevue/fileupload";

export const ttableComponents = {
  Button,
  DataTable,
  Column,
  InputText,
  Checkbox,
  CustomCheckbox,
  FileUpload,
  TTableFilters,
};